module.exports = __webpack_public_path__ + "static/media/surreyfield.6f142df5.jpg";